module.exports = __webpack_public_path__ + "media/images/pages/team-5-b454c573854d6c4558e02b3f663ffea2.jpg";